import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Layout } from '../widgets'

import beatsImg from '../images/beats.svg'
import trackImg from '../images/track.svg'

import * as routes from '../routes'

class Submit extends React.Component {
  render() {
    return (
      <div className='body-container'>
        <Layout>
          <Layout.Header>Upload</Layout.Header>
          <div className='layout-content'>
            <p className='submit-intro'>Does your Music File contain any rapping or singing?</p>
            <div className='submit-ctas'>
              <div className='submit-ctas__container'>
                <div>
                  <p>Yes, it contains vocals created in Voloco</p>
                </div>
                <br />
                <Link to={routes.producerTopTracksSubmitPath}>
                  <Button>
                    <img src={trackImg} alt='' />
                    Upload a Track
                  </Button>
                </Link>
              </div>
              <div className='submit-ctas__container'>
                <div>
                  <p>No, it does not contain vocals</p>
                </div>
                <br />
                <Link to={routes.producerBeatsSubmitPath}>
                  <Button>
                    <img src={beatsImg} alt='' />
                    Upload a Beat
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </Layout>
      </div>
    )
  }
}

export default Submit
